export const boxQueryKeys = {
  id: 'id',
  name: 'container_name',
  user: {
    id: 'user_id',
    name: 'user_name',
  },
  branch: {
    id: 'branch_id',
    name: 'branch_name',
  },
  declarationCount: 'declaration_count',
  createdAt: 'created_at',
};
